import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=15031d3d&"
import script from "./BookingCard.vue?vue&type=script&lang=js&"
export * from "./BookingCard.vue?vue&type=script&lang=js&"
import style0 from "./BookingCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports